module.exports = __webpack_public_path__ + "static/media/icon-agep-doorway.08d9184f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Layout/assets/img/icon-agep-doorway.svg
// module id = 655
// module chunks = 0